<template>
<div :class="bem()">
  <UniversalCard
    v-for="card in props.cards"
    :key="card.id"
    :item="card"
    :aspect-ratio="'6/4'"
    :class="bem('item')"
  />
</div>
</template>

<script setup lang="ts">
interface AccordionCardGridProps {
  cards: {
    id: string
    colour: string
    linkText: string
  }[]
}

const props = defineProps<AccordionCardGridProps>()

const bem = useBEM('AccordionCardGrid')
</script>

<style lang="postcss" scoped>
.AccordionCardGrid {
  @apply flex flex-wrap gap-4;
}

.AccordionCardGrid__item {
  width: calc(50% - 0.5rem);
}
</style>